// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3olTK","author-details":"MCFDy","image-wrapper":"_3y0wZ"};